import React, { useState } from "react";
import Modal from "../../../../parts/modal-new";
import { useRillContext } from "../../../../rill/RillReact/share/base";
import { useTranslation } from "react-i18next";

function ConfirmRemoveAthlete(props) {
  const { locals } = useRillContext();

  const {
    params,
    query,
    editExercise,
    activeUser,
    athlete,
    coachOrganizationInformation = undefined,
  } = locals;
  const { t } = useTranslation(["athlete-portal", "common"]);
  const [isRemoving, setIsRemoving] = useState(false);
  const referAsClients = Boolean(activeUser.referAsClients);
  const entity = t(referAsClients ? "programs.client" : "programs.athlete");

  return (
    <form
      onSubmit={() => setIsRemoving(true)}
      action={`/actions/user/remove-athlete/${athlete._id}`}
      method="POST"
      data-noreset
    >
      <input type="hidden" name="athlete" value={JSON.stringify(athlete)} />
      <Modal
        width="600px"
        title={t("confirmRemoveAthlete.title", { entity })}
        className="stop-training-modal remove"
      >
        <div className="body">
          <div className="columns">
            <div className="column" data-col="1/1">
              <b>{t("confirmRemoveAthlete.pleaseAcknowledge", { entity })}</b>

              <div>
                <input
                  id="coachOrganizationInformation"
                  name="coachOrganizationInformation"
                  defaultValue={JSON.stringify(coachOrganizationInformation)}
                  style={{ display: "none" }}
                />
              </div>
              <div>
                <label className="checkbox-input">
                  <input
                    id="remove-athlete-programs-confirm"
                    name="acknowledge"
                    type="checkbox"
                    value="programs"
                  />

                  <span className="text">
                    {t("confirmRemoveAthlete.noLongerSeePrograms", { entity })}
                  </span>
                </label>
              </div>
              <div>
                <label className="checkbox-input">
                  <input
                    id="remove-athlete-profile-confirm"
                    name="acknowledge"
                    type="checkbox"
                    value="profile"
                  />

                  <span className="text">
                    {t("confirmRemoveAthlete.noLongerViewProfile", { entity })}
                  </span>
                </label>
              </div>
              <div>
                <label className="checkbox-input">
                  <input
                    id="remove-athlete-list-confirm"
                    name="acknowledge"
                    type="checkbox"
                    value="list"
                  />

                  <span className="text">
                    {t("confirmRemoveAthlete.noLongerDisplayed", { entity })}
                  </span>
                </label>
              </div>
            </div>
          </div>
        </div>

        <footer>
          <a
            role="button"
            data-button-type="secondary"
            data-action="cancel"
            href="/actions/refresh?modal="
          >
            {t("common:cancel")}
          </a>
          <div className="columns">
            <div className="column" data-col="1/2">
              {!isRemoving ? (
                <button data-button-type="primary" type="submit">
                  {t("common:remove")}
                </button>
              ) : (
                <button
                  style={{ cursor: "wait" }}
                  data-button-type="primary"
                  type="button"
                  disabled
                >
                  {t("common:remove")}
                </button>
              )}
            </div>
          </div>
        </footer>
      </Modal>
    </form>
  );
}

export default ConfirmRemoveAthlete;
